'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalloutCard = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalloutCard = exports.CalloutCard = function CalloutCard(props) {
  var callout = props.callout,
      calloutNote = props.calloutNote,
      ctaCopy = props.ctaCopy,
      details = props.details,
      extraClass = props.extraClass,
      handleClick = props.onClick,
      selected = props.selected,
      tag = props.tag;


  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('plan', {
        'plan--selected': selected
      }, extraClass),
      onClick: handleClick
    },
    _react2.default.createElement(
      'div',
      { className: 'plan__choice md-hidden' },
      _react2.default.createElement('input', { type: 'radio', checked: selected, readOnly: true })
    ),
    _react2.default.createElement(
      'div',
      { className: 'plan__content' },
      tag && _react2.default.createElement(
        'div',
        { className: 'plan__tag' },
        _react2.default.createElement(
          'span',
          null,
          tag
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'plan__top' },
        _react2.default.createElement(
          'div',
          { className: 'plan__callout' },
          callout
        ),
        calloutNote && _react2.default.createElement(
          'p',
          { className: 'plan__note' },
          calloutNote
        ),
        details && _react2.default.createElement(
          'div',
          { className: 'plan__details' },
          details
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'md-block hidden' },
        _react2.default.createElement(
          'button',
          { className: 'bt bt--primary bt--lg bt--width-full' },
          ctaCopy
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'md-block hidden' },
        props.children
      )
    )
  );
};

CalloutCard.propTypes = {
  callout: _propTypes2.default.node.isRequired,
  calloutNote: _propTypes2.default.node,
  children: _propTypes2.default.node,
  ctaCopy: _propTypes2.default.node.isRequired,
  extraClass: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  details: _propTypes2.default.node,
  tag: _propTypes2.default.node
};